export default "__VITE_ASSET__BaRSUoeG__"